export interface CredibilityColor {
  /** RGB строка для использования в style */
  rgb: string;
  /** Tailwind класс для текста */
  textClass: string;
}

/**
 * Утилита для определения цвета в зависимости от значения credibility
 * 
 * Логика цветов:
 * - credibility < 0: серый
 * - credibility >= 80: зеленый
 * - credibility >= 60: желтый
 * - credibility >= 40: оранжевый
 * - credibility < 40: красный
 * 
 * @param credibility - значение индекса доверия
 * @returns объект с rgb строкой и Tailwind классом
 */
export function getCredibilityColor(credibility: number | undefined | null): CredibilityColor {
  const value = credibility ?? -1;

  if (value < 0) {
    return {
      rgb: "rgb(156, 163, 175)", // gray-400
      textClass: "text-gray-400",
    };
  }

  if (value >= 80) {
    return {
      rgb: "#91C000",
      textClass: "text-[#91C000]",
    };
  }

  if (value >= 60) {
    return {
      rgb: "#EBB518",
      textClass: "text-[#EBB518]",
    };
  }

  if (value >= 40) {
    return {
      rgb: "#F97101",
      textClass: "text-[#F97101]",
    };
  }

  return {
    rgb: "#D15B46",
    textClass: "text-[#D15B46]",
  };
}
